export default __webpack_public_path__ + "static/media/placeholder_dummy2016-lebenslaufbusiness01-mobile.1777ea73.png";